module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADuSURBVChTY2RxsPrH+OPv298nTooyYAGs5uYv/nOyiDH9v/d89X8OJhFWM7PnUDk4YDE2ffSfk0n8/5M3u8ECzNLyi1kcLP+zWli8AgsAAYup2VOQGLO88lqwANCkZwwsLNYwxSBTmA1N7kAUKa1hYGY2ZtbWOwN2I0jDnwPHmJgkpKczachlgPj/771Y+ffR/Qiw/H/G/wwMjIyyLA7W/6AaWJkkZWaBTAcpBomBxZmYtEB8IGAUgQsC2UABVjgfaBBYBYgAA0ZGRRY7qzsMjP+hYowMfw6dMGT49/cihI8MgFbATQJ6AioKBAwMAAwvUD7cM624AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/default/bottom_arrow.png
// module id = Cwfp
// module chunks = 1